import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Login } from './pages/Login';
import { Welcome } from './pages/Welcome';
import { AppLayout } from './components/shell/AppLayout';
import { Overview } from './pages/Overview';
import { Today } from './pages/Today';
import { Patients } from './pages/Patients';
import { PatientDetail } from './pages/PatientDetail';
import { CareSignals } from './pages/CareSignals';
import { Report } from './pages/Report';

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<Login />} />
        <Route path="/welcome" element={<Welcome />} />
        <Route element={<AppLayout />}>
          <Route path="/overview" element={<Overview />} />
          <Route path="/today" element={<Today />} />
          <Route path="/patients" element={<Patients />} />
          <Route path="/patients/:id" element={<PatientDetail />} />
          <Route path="/patients/:id/report" element={<Report />} />
          <Route path="/signals" element={<CareSignals />} />
        </Route>
        <Route path="*" element={<Navigate to="/overview" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
